import { render } from "./AutoSystemClassificationPage.vue?vue&type=template&id=4494eb03&scoped=true&ts=true"
import script from "./AutoSystemClassificationPage.vue?vue&type=script&lang=ts"
export * from "./AutoSystemClassificationPage.vue?vue&type=script&lang=ts"

import "./AutoSystemClassificationPage.vue?vue&type=style&index=0&id=4494eb03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4494eb03"]])

export default __exports__